export function loanDemandReducer(state = {
    ALL: {},
    BY_EQUIPEMENT: {},
    BY_USER: {},
    USER: {}
} ,{
    type,
    payload
}){
    
    switch(type){
        case "NEW_LOAN_DEMAND":    
        case "UPDATE_LOAN_DEMAND_USER":
            let list0 = Object.assign({}, state);
            list0.USER[payload.demand_loan_id] = payload
        
            return list0 
           
        case "UPDATE_LOAN_DEMAND":
            let list = Object.assign({}, state);
            list.ALL[payload.demand_loan_id] = payload

            return list
            
        case "GET_LOAN_DEMANDS":
            let list2 = Object.assign({}, state);
            list2.ALL = payload
        
            return list2
        
        case "GET_USER_LOAN_DEMANDS": // connected user
            let list3 = Object.assign({}, state);
            list3.USER = payload
        
            return list3

        case "GET_EQUIPEMENT_LOAN_DEMANDS":
            let list4 = Object.assign({}, state);

            list4.BY_EQUIPEMENT[payload.equipementID] = payload.list
            list4.ALL = Object.assign(list4.ALL, payload.list)
        
            return list4

        case "GET_USER_LOAN_DEMANDS_ADMIN":
            let list5 = Object.assign({}, state);
            list5.BY_USER[payload.userID] = payload.list
            list5.ALL = Object.assign(list5.ALL, payload.list)
        
            return list5
        case "DELETE_LOAN_DEMAND":
            let list6 = Object.assign({}, state);
            
            delete list6.USER[payload]
            return list6
        default:
            return state;
    }
    
}